# Querying a job ad

## Operations

### positionProfile

The [`positionProfile` query] returns the current state of a job ad.
In addition to the fields you provided during posting, it returns the URL of a live job ad and the end date of the posting.

Posting job ads to the SEEK job board is an asynchronous process.
Until the job ad has gone live the `positionProfile` query will return `null`.
The [`PositionProfilePosted` event] can be used to trigger a query of the position profile once it’s available,
and the `PositionProfileUpdated` event can be used for trigger behaviour on subsequent updates to it.

You can determine if a job ad is closed based on its [`postingInstructions.end` field].
If the posting end date is in the past then the job ad was closed on the specified date.
The [`PositionProfileClosed` event] is emitted when a job ad has been closed.

The [`PositionProfile`] object will remain for 180 days past its close date, after which the `positionProfile` query will return `null`.
Your software must store any data it needs to access after the 180 day period.

[`positionprofile`]: /schema/named-type/PositionProfile
[`positionprofile` query]: /schema/query/positionProfile
[`positionprofileclosed` event]: /use-cases/job-posting/managing-job-ads/closing-a-job-ad#positionprofileclosed
[`positionprofileposted` event]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad#positionprofileposted
[`postinginstructions.end` field]: /schema/named-type/PostingInstruction#/field/end

```graphql
query ($id: String!) {
  positionProfile(id: $id) {
    profileId {
      value
    }
    positionTitle
    positionUri
    postingInstructions {
      start
      end
    }
  }
}
```

```json
{
  "id": "seekAnzPublicTest:positionProfile:jobAd:27cuZeA47"
}
```

```json
{
  "positionProfile": {
    "profileId": {
      "value": "seekAnzPublicTest:positionProfile:jobAd:27cuZeA47"
    },
    "positionTitle": "Customer Mobility Director",
    "positionUri": "https://au.candidate.example.seek.com/job/30000001",
    "postingInstructions": [
      {
        "start": "2019-08-25T21:24:16.735Z",
        "end": "2038-01-01T00:00:00.000Z"
      }
    ]
  }
}
```
